import {
    signInWithEmailAndPassword,
    createUserWithEmailAndPassword,
    updateProfile,
    signOut,
} from 'firebase/auth';
import { auth, db } from '../config/firebase';
import { doc, setDoc, serverTimestamp, getDoc } from 'firebase/firestore';

export const authService = {
    /**
     * Connexion utilisateur
     */
    async login(email, password) {
        try {

            const trimmedEmail = email.trim();
            const trimmedPassword = password.trim();

            const userCredential = await signInWithEmailAndPassword(
                auth,
                trimmedEmail,
                trimmedPassword
            );

            return userCredential.user;
        } catch (error) {
            console.error('[authService] Erreur connexion:', error.code, error.message);
            throw error;
        }
    },

    /**
     * Inscription utilisateur (rôle par défaut: client)
     */
    async register(userData) {
        try {

            const trimmedEmail = userData.email.trim();
            const trimmedPassword = userData.password.trim();

            const userCredential = await createUserWithEmailAndPassword(
                auth,
                trimmedEmail,
                trimmedPassword
            );

            const user = userCredential.user;

            // Mettre à jour le profil Firebase Auth
            await updateProfile(user, {
                displayName: userData.name,
            });

            // Créer le document utilisateur dans Firestore
            const userDocRef = doc(db, 'users', user.uid);
            await setDoc(userDocRef, {
                uid: user.uid,
                name: userData.name.trim(),
                email: user.email,
                phone: userData.phone.trim(),
                role: 'client', // RÔLE CLIENT PAR DÉFAUT
                createdAt: serverTimestamp(),
                updatedAt: serverTimestamp(),
            });


            return user;
        } catch (error) {
            console.error('[authService] Erreur inscription:', error.code, error.message);
            throw error;
        }
    },

    /**
     * Créer un utilisateur admin (pour les admins uniquement)
     */
    async createAdmin(userData) {
        try {

            const trimmedEmail = userData.email.trim();
            const trimmedPassword = userData.password.trim();

            const userCredential = await createUserWithEmailAndPassword(
                auth,
                trimmedEmail,
                trimmedPassword
            );

            const user = userCredential.user;

            // Mettre à jour le profil Firebase Auth
            await updateProfile(user, {
                displayName: userData.name,
            });


            // Créer le document utilisateur dans Firestore avec rôle ADMIN
            const userDocRef = doc(db, 'users', user.uid);
            await setDoc(userDocRef, {
                uid: user.uid,
                name: userData.name.trim(),
                email: user.email,
                phone: userData.phone?.trim() || '',
                role: 'admin', // RÔLE ADMIN
                createdAt: serverTimestamp(),
                updatedAt: serverTimestamp(),
            });

            return user;
        } catch (error) {
            console.error('[authService] Erreur création admin:', error.code, error.message);
            throw error;
        }
    },

    /**
     * Déconnexion
     */
    async logout() {
        try {
            await signOut(auth);

        } catch (error) {
            console.error('[authService] Erreur déconnexion:', error);
            throw error;
        }
    },


    /**
     * Récupérer le rôle de l'utilisateur
     */
    async getUserRole(uid) {
        try {
            if (!uid) {
                return 'client';
            }

            // Créer la référence
            const userDocRef = doc(db, 'users', uid);

            // Récupérer le document
            const userDocSnap = await getDoc(userDocRef);

            if (userDocSnap.exists()) {
                const userData = userDocSnap.data();
                const role = userData.role;

                return role;
            }

            return 'client';
        } catch (error) {
            console.error('[authService] Erreur:', error);
            console.error('[authService] Message:', error.message);
            console.error('[authService] Code:', error.code);
            return 'client';
        }
    },



    /**
     * Vérifier si l'utilisateur est admin
     */
    async isAdmin(uid) {
        try {
            const role = await this.getUserRole(uid);
            return role === 'admin';
        } catch (error) {
            console.error('[authService] Erreur vérification admin:', error);
            return false;
        }
    },

    /**
     * Récupérer les données utilisateur
     */
    async getUserData(uid) {
        try {

            const userDocRef = doc(db, 'users', uid);
            const userDocSnap = await getDoc(userDocRef);

            if (userDocSnap.exists()) {
                const userData = userDocSnap.data();
                return userData;
            }

            return null;
        } catch (error) {
            console.error('[authService] Erreur:', error);
            throw error;
        }
    },
};
